import React from 'react';
import PropTypes from 'prop-types';
import arrowIcon from '../../../images/icons/chevron-left.svg';
import styles from './SliderArrows.module.sass';
import ClickableDiv from '../clickable_div/ClickableDiv';

function SliderArrows(props) {
  const {
    onPrevClick, onNextClick, hidePrevArrow, hideNextArrow,
  } = props;
  return (
    <div className={styles['pagination-arrows']}>
      <ClickableDiv
        className={`${styles.prev} ${hidePrevArrow && styles.invisible}`}
        onClick={onPrevClick}
      >
        <img src={arrowIcon} alt="Previous Page" />
      </ClickableDiv>
      <ClickableDiv
        className={`${styles.next} ${hideNextArrow && styles.invisible}`}
        onClick={onNextClick}
      >
        <img src={arrowIcon} alt="Next Page" />
      </ClickableDiv>
    </div>
  );
}

SliderArrows.propTypes = {
  onPrevClick: PropTypes.func.isRequired,
  onNextClick: PropTypes.func.isRequired,
  hidePrevArrow: PropTypes.bool.isRequired,
  hideNextArrow: PropTypes.bool.isRequired,
};

export default SliderArrows;
